<template>
  <div>
    <!--1.头部-->
    <header-frame></header-frame>

    <!--3.一级导航-->
    <first-menu></first-menu>

    <div class="wrap">
      <div class="layout-name">联系我们</div>
      <div>
        <div class="map">
          <iframe
            src="./static/map.html"
            width="100%"
            height="184"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </div>
        <div class="contact-title">联系电话</div>
        <div class="contact-content">025-84658665</div>
        <div class="contact-title">传真号码</div>
        <div class="contact-content">025-84658765</div>
        <div class="contact-title">公司地址</div>
        <div class="contact-content">江苏省南京市江东中路399号紫金金融中心A2栋江苏交控大厦</div>
      </div>
    </div>

    <!--10.footer-->
    <footer-frame></footer-frame>
  </div>
</template>

<script>
import HeaderFrame from '@/components/Header';
import FirstMenu from '@/components/FirstMenu';
import FooterFrame from '@/components/Footer';

export default {
  components: {
    HeaderFrame,
    FirstMenu,
    FooterFrame,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.wrap {
  margin-bottom: calc-width(30vw);
  padding: 0 calc-width(20vw);
  /*border: 1px solid red;*/
  /*max-width: calc(100% - calc-width(40vw));*/
}

.layout-name {
  color: $primary-color;
  font-weight: bold;
  padding: calc-width(25vw) 0;
}

.contact-title {
  margin-top: calc-width(20vw);
  margin-bottom: calc-width(8vw);
  font-size: calc-width(14vw);
}

.contact-content {
  font-size: calc-width(12vw);
  color: $primary-color;
}
</style>



// WEBPACK FOOTER //
// src/pages/content/Contact.vue